import { defineStore } from 'pinia'
import { api, mock } from '@/services'

export const useSpacesStore = defineStore('spaces', {
    state: () => {
        return {
            loading: {},
            spaces: {},
            lastVisitedTabNames: {
                unnested: null,
                nested: null,
            },
        }
    },
    getters: {
        lastVisitedTabName(state) {
            return (nested) => {
                return state.lastVisitedTabNames[nested ? 'nested' : 'unnested']
            }
        },
    },
    actions: {
        clear() {
            this.loading = {}
            this.spaces = {}
        },
        async fetch(space = 'me') {
            const appStore = useAppStore()

            if (mock.mockingSpace()) {
                this.spaces[space] = mock.content()?.spaces?.[space]
                return
            }

            this.loading[space] = true
            return api.get(`/${appStore.id}/spaces/${space}`)
                .then(({ data }) => {
                    this.spaces[space] = data
                })
                .finally(() => {
                    delete this.loading[space]
                })
        },
        updateLastVisitedTab(title, nested) {
            this.lastVisitedTabNames[nested ? 'nested' : 'unnested'] = title
        },
    },
})
